:host {
    display: block;
}

.border-b-color {
    border-bottom-color: var(--color-border-banner-tab-group);
}